// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__2znDK","sk-rotateplane":"Spinner_sk-rotateplane__2TCZp"};